<template>
    <div class="element-pdf is-empty">
        <pdf-embed :src="url(smartlink)" :printing="printing" v-if="!options('smartlink') || smartlink"></pdf-embed>
    </div>
</template>

<script>
    import store from '../../store'
    import Pdf   from '../../../components/Pdf'

    export default {
        props: {
            definition: { type: Object, required: true },
            element:    { type: Object, required: true },
        },
        computed: {
            preview()   { return store.state.preview === true },
            printing()  { return store.state.printing },
            smartlink() { return this.options('smartlink') ? store.getters.smartlink(this.options('smartlink'), this.element, 'pdf') : ''},
        },
        methods: {
            classes(index) { return store.getters['classes'](index) },
            macro  (value) { return store.getters['macro'](value) },
            options(value) { return store.getters['options'](this.definition, value) },
            url    (url)   {
                return url && url.length > 0 ? ((this.preview ? '/app/engagements/file/' : '/e/media/file/') + store.state.id + '/' + url) : this.options('file') 
            },
        },
        components: {
            'pdf-embed': Pdf,
        }
    }
</script>
